'use client';
import { useTranslation } from '@/lib/i18n/i18n.client';
import { cn } from '@/lib/utils';

import { TargetIcon } from '@/blocks/Scraper/TargetIcon';
import LinkButton from '@/components/atoms/LinkButton';
import { Text } from '@/components/atoms/Text';

import { Target } from '../constants/targets';
import { useScraperTranslations } from '../scraperTranslations';
import { optionStyle } from './ScraperOption';

import { env } from '@/constant/env';
import { useMemo } from 'react';
import iconExternalSrc from '~/svg/IconExternal.svg';
import { SvgIcon } from '@/components/SvgIcon';

const DASHBOARD_URL =
  env.publicLocale === 'zh-cn'
    ? 'https://dashboard.decodo.cn/'
    : 'https://dashboard.decodo.com/';

type Props = {
  target: Target;
};

const getHref = (target: Target) => {
  const queryParams = new URLSearchParams();

  queryParams.set('target', target.name);
  queryParams.set('page', 'playground');

  return `${DASHBOARD_URL}?${queryParams.toString()}`;
};

const ExternalOption = ({ target }: Props) => {
  const { texts } = useTranslation();

  const { getTranslation } = useScraperTranslations();

  const href = useMemo(() => getHref(target), [target]);

  return (
    <LinkButton href={href} noStyles>
      <li className={cn(optionStyle, 'flex justify-between text-gray-500 dark:text-gray-dark-400')}>
        <div className='flex items-center gap-3'>
          <div className='opacity-60'>
            <TargetIcon target={target} />
          </div>
          <Text classNames={{ wrapper: 'text-body-l text-left text-gray-500 dark:text-gray-dark-400' }}>
            {getTranslation(target.label) || ''}
          </Text>
        </div>
        <div className='flex items-center gap-1 py-2.5'>
          <Text
            classNames={{
              wrapper:
                'text-body-m text-gray-500 dark:text-gray-dark-400 hover:underline',
            }}
          >
            {texts.scraper.open_in_dashboard}
          </Text>
          <SvgIcon src={iconExternalSrc} className='w-4 h-4 text-gray-500 dark:text-gray-dark-400' />
        </div>
        {/* </LinkButton> */}
      </li>
    </LinkButton>
  );
};

export default ExternalOption;
